<!-- <app-header [headerTitle]="headerTitle"></app-header> -->
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<div class="breadCrumb">
    <div class="left-box">
        <img [routerLink]="'/my-dashboard'" src="../../assets/images/backarrlibrary.svg" alt="">
        <span class="learning">Learning Centre ></span>
        <span class="library">Personal Analytics</span>
    </div>
    <div [routerLink]="'/profile-page'" class="profile">
        <img [src]="userPic ? userPic : '../../../../../assets/images/user (1).png'" id="header_img">
        <span *ngIf="userName">{{userName}}</span>
    </div>
</div>
<div class="analytics_page">

    <h2 class="head">
        My Personal Analytics
    </h2>

    <div class="main_container">
        <div class="first-row-1 analytics_page_left_side">

            <div class="first_container">

                <div class="container tp-wrapper c-1">
                    <div class="tp-box" [@flipState]="flip1" (click)="toggleFlip(1)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Lifetime D.O.S.Es Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Lifetime <br> DOSEs
                            </div> -->
                            <div class="digit-data">
                                <div *ngIf="lifetimeDoses === -1; else fetchedLifetimeDoses" class="digit_obtain">
                                    Loading...
                                </div>
                                <ng-template #fetchedLifetimeDoses>
                                    <div class="digit_obtain">{{ lifetimeDoses }}</div>
                                </ng-template>
                            </div>
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Lifetime D.O.S.Es Back.png" alt="img">
                            <!-- <div class="c-heading">
                                My Lifetime <br> D.O.S.Es
                            </div>
                            <div class="digit-data">
                                <p class="para-g">From your first D.O.S.E™<br>
                                    to your latest,<br>
                                    we’ll track them all!<br>
                                    Keep building those learning<br>
                                    muscles, and watch this<br>
                                    number soar!</p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(1)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>

                <div class="container tp-wrapper c-2">
                    <div class="tp-box" [@flipState]="flip2" (click)="toggleFlip(2)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total View Time Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> View Time
                            </div> -->
                            <div class="digit-data">
                                <div class="digit_obtain">{{ hasProgress ? totalViewTime : 0 }}</div>
                            </div>
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total View Time Back.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> View Time
                            </div>
                            <div class="digit-data">
                                <p class="para-g">You’ll be amazed at how<br>
                                    quickly your D.O.S.E™ time<br>
                                    will grow. A little bit, every<br>
                                    day, and in no time your<br>
                                    commitment will show.
                                    </p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(2)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>

                <div class="container tp-wrapper c-3">
                    <div class="tp-box" [@flipState]="flip3" (click)="toggleFlip(3)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Average Weekly Time Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Average <br> Weekly Time
                            </div> -->
                            <div class="digit-data">
                                <div class="digit_obtain">{{ hasProgress ? weeklyTime: 0 }}</div>
                            </div>
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Average Weekly Time Back.png" alt="img">
                            <!-- <div class="c-heading">
                                My Average <br> Weekly Time
                            </div>
                            <div class="digit-data">
                                <p class="para-g">Our brains love repetition, and<br>
                                    thrive when good habits form,<br>
                                    so get the most out of your<br>
                                    D.O.S.E™s, by making<br>
                                    everyday learning your norm!
                                    </p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(3)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>

                <div class="container tp-wrapper c-4">
                    <div class="tp-box" [@flipState]="flip4" (click)="toggleFlip(4)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total Quizzes Completed Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> Quizzes Completed
                            </div> -->
                            <div class="digit-data">
                                <div class="digit_obtain">{{ hasProgress ? getQuizzesCompleted() : 0 }}</div>
                            </div>
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total Quizzes Completed Back.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> Quizzes Completed
                            </div>
                            <div class="digit-data">
                                <p class="para-g">With every quiz your<br>
                                    knowledge will build. We’re into<br>
                                    compound learning, not just<br>
                                    answers filled. So as much as<br>
                                    some might seem cheesy,<br>
                                    compound learning happens<br>
                                    when the answers are easy!
                                    </p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(4)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>

                <div class="container tp-wrapper c-5">
                    <div class="tp-box" [@flipState]="flip5" (click)="toggleFlip(5)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Average Quiz Score Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Average <br> Quiz Score
                            </div> -->
                            <div class="digit-data">
                                <div class="digit_obtain">{{ hasProgress ? averageQuizScore : 0 }}%</div>
                            </div>

                            <!-- <div class="graph_container btnn btnn-default">
                                <div id="chart" class="area_chart">

                                    <apx-chart [grid]="chartOptions.grid" [series]="chartOptions.series"
                                        [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis" [stroke]="chartOptions.stroke"
                                        [tooltip]="chartOptions.tooltip" [dataLabels]="chartOptions.dataLabels"></apx-chart>
                                </div>
                            </div> -->
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Average Quiz Score Back.png" alt="img">                            <!-- <div class="c-heading">
                                My Average <br> Quiz Score
                            </div>
                            <div class="digit-data">
                                <p class="para-g">This isn’t school,<br>
                                    this is a tool.<br>
                                    If you don’t get<br>
                                    a perfect score,<br>
                                    just take the quiz<br>
                                    once more!
                                    </p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(5)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>

                <div class="container tp-wrapper c-6">
                    <div class="tp-box" [@flipState]="flip6" (click)="toggleFlip(6)">
                        <div class="tp-box__side tp-box__front">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total Accrued Points Front.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> Accrued Points
                            </div> -->
                            <div class="digit-data">
                                <div class="digit_obtain">{{ hasProgress ? totalEarnedPts : 0 }}</div>
                            </div>
                        </div>
                        <div class="tp-box__side tp-box__back">
                            <img src="../../../../../assets/images/Personal Analytics Tiles/My Total Accrued Points Back.png" alt="img">
                            <!-- <div class="c-heading">
                                My Total <br> Accrued Points
                            </div>
                            <div class="digit-data">
                                <p class="para-g">We’ll store your points for a<br>
                                    later date, because we’re<br>
                                    building something fun to<br>
                                    heighten your learning state.<br>
                                    So stand by D.O.S.E™’er,<br>
                                    & we’ll let you know,<br>
                                    when our latest idea,<br>
                                    is even closer!
                                    </p>
                            </div>     -->
                        </div>
                    </div>

                    <!-- <div (click)="toggleFlip(6)" class="toggle-arrow">
                        <mat-icon>north_west</mat-icon>
                    </div> -->
                </div>
            </div>

             <!-- <div class="courses">
                <h2 class="my_courses">My Programs</h2>

                <div class="course_status_main_container">
                    <div class="course_status_container">
                        <div class="percentage_of_course">{{getCountCourseLevel('easy')}}</div>
                        <div class="level_course">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second transparent"></span>
                                <span class="third transparent"></span>
                            </div>
                            <span class="level">Easy</span>
                        </div>
                    </div>

                    <div class="course_status_container">
                        <div class="percentage_of_course">{{getCountCourseLevel('medium')}}</div>
                        <div class="level_course">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third transparent"></span>
                            </div>
                            <span class="level">Medium</span>
                        </div>
                    </div>

                    <div class="course_status_container">
                        <div class="percentage_of_course">{{getCountCourseLevel('hard')}}</div>
                        <div class="level_course">
                            <div class="level_easy">
                                <span class="first colored"></span>
                                <span class="second colored"></span>
                                <span class="third colored"></span>
                            </div>
                            <span class="level">Hard</span>
                        </div>
                    </div>

                    <div class="course_status_container">
                        <div class="percentage_of_course in_prog">{{ hasProgress ? progressProgram('inProgress') : 0 }}</div>
                        <div class="level_course">
                            <span class="level">In Progress</span>
                        </div>
                    </div>

                    <div class="course_status_container">
                        <div class="percentage_of_course not_started">{{progressProgram('notStarted')}}</div>
                        <div class="level_course">
                            <span class="level">Not Started</span>
                        </div>
                    </div>

                    <div class="course_status_container">
                        <div class="percentage_of_course completed">{{ hasProgress ? progressProgram('completed') : 0 }}</div>
                        <div class="level_course">
                            <span class="level">Completed</span>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="second-prg-container">
                <h6>My Programs</h6>
                <div class="main-prg-box">
                    <div style="margin-bottom: 5px;">
                        <div class="top-rating">
                            <div class="rating-h">COMPLETION</div>
                            <div class="rating-l">
                                <span>0</span>
                                <span>{{totalProgressCount/2}}</span>
                                <span>{{totalProgressCount}}</span>
                            </div>
                        </div>
                        <div class="bar-box">
                            <div class="b-hd">Available</div>
                            <div class="bar">
                                <div id="b-1" [ngStyle]="{'width': totalProgressCount ? 100 + '%' : 0 + '%'}" style="width: 100%;"><span>{{totalProgressCount}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="bar-box">
                        <div class="b-hd">Not Started</div>
                        <div class="bar">
                            <div id="b-2" [ngStyle]="{'width': getProgressPercentage(totalProgressCount, notStartedCount) + '%'}"><span>{{notStartedCount}}</span></div>
                        </div>
                    </div>
                    <div class="bar-box">
                        <div class="b-hd">In Progress</div>
                        <div class="bar">
                            <div id="b-3" [ngStyle]="{'width': getProgressPercentage(totalProgressCount, inProgressCount) + '%'}"><span>{{inProgressCount}}</span></div>
                        </div>
                    </div>
                    <div class="bar-box">
                        <div class="b-hd">Completed</div>
                        <div class="bar">
                            <div id="b-4" [ngStyle]="{'width': getProgressPercentage(totalProgressCount, completedCount) + '%'}"><span>{{completedCount}}</span></div>
                        </div>
                    </div>

                    <div style="margin-bottom: 5px;">
                        <div class="top-rating">
                            <div class="rating-h">DIFFICULTY</div>
                        </div>
                        <div class="bar-box">
                            <div class="b-hd">Easy</div>
                            <div class="bar">
                                <div id="b-5" [ngStyle]="{'width': getProgressPercentage(totalLevelCount, easyCount) + '%'}"><span>{{easyCount}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="bar-box">
                        <div class="b-hd">Medium</div>
                        <div class="bar">
                            <div id="b-6" [ngStyle]="{'width': getProgressPercentage(totalLevelCount, mediumCount) + '%'}"><span>{{mediumCount}}</span></div>
                        </div>
                    </div>
                    <div class="bar-box">
                        <div class="b-hd">Hard</div>
                        <div class="bar">
                            <div id="b-7" [ngStyle]="{'width': getProgressPercentage(totalLevelCount, hardCount) + '%'}"><span>{{hardCount}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="analytics_page_right_side">

            <div class="second_container">
                <h2 class="sec_container_head">
                    My Favourite Categories
                </h2>

                <div class="categ_bars" *ngIf="progressBar?.length">
                    <ng-container *ngFor="let progress of progressBar">
                        <h2 class="bar_head">{{progress.name}}</h2>
                        <div class="progress_bar">
                            <div class="complete progress" style="height: 10px">
                                <div role="progressbar" class="progress-bar" [style.width]="progress.progressPercentage + '%'"
                                    [att.aria-valuenow]="progress.progressPercentage" aria-valuemin="0" [attr.aria-valuemax]="userProgress?.length">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <!-- <div class="categ_bars">
                    <h2 class="bar_head">Management</h2>
                    <div class="progress_bar">

                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="'100%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="0">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="categ_bars">
                    <h2 class="bar_head">Personal Growth</h2>
                    <div class="progress_bar">

                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="'50%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="categ_bars">
                    <h2 class="bar_head">Support Centre</h2>
                    <div class="progress_bar">

                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="'30%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="categ_bars">
                    <h2 class="bar_head">Warehouse</h2>
                    <div class="progress_bar">

                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="'10%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="categ_bars">
                    <h2 class="bar_head">Well Being</h2>
                    <div class="progress_bar">

                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="'90%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>

            <div class="right-side-box">
                <div class="a-quote-img-box">
                    <img src="../../../../../assets/images/personal-analytics/PERSONAL ANALYTICS_QUOTE.png" alt="">
                </div>
                <!-- <div class="daily_dose_container">
                    <div class="text_container">
                        <h2>Daily D.O.S.E</h2>
                        <p>Remember, it only takes 5 - 10 minutes a day and your learning journey will be on it’s way</p>
                    </div>
                    <div class="img_container">
                        <img src="../../assets/gifs/Flip_hands_wink_wave_pose.gif" alt="" id="gif" loop>
                    </div>
                </div> -->


                <div class="average_course_container">
                    <div class="container">
                        <h2>My Industry Av.</h2>
                        <p *ngIf="industryAverage === -1; else fetchedIndustryAverage">Loading...</p>
                        <ng-template #fetchedIndustryAverage>
                            <p>{{ industryAverage }} / month</p>
                        </ng-template>
                        <h3>Completing Daily
                            D.O.S.E's</h3>
                    </div>

                    <div class="container">
                        <h2>My Company Av.</h2>
                        <p *ngIf="companyAverage === -1; else fetchedCompanyAverage">Loading...</p>
                        <ng-template #fetchedCompanyAverage>
                            <p>{{ companyAverage }} / month</p>
                        </ng-template>
                        <h3>Completing Daily
                            D.O.S.E's</h3>
                    </div>

                    <div class="container">
                        <h2>My Monthly Av.</h2>
                        <p>{{ hasProgress ? monthlyAverage : 0 }} / month</p>
                        <h3>Completing Daily
                            D.O.S.E's</h3>
                    </div>
                </div>
            </div>


        </div>
    </div>


</div>

<!-- <div class="analytics_page">
    <app-header [headerTitle]="headerTitle"></app-header>


    <div class="analytics_container_main">
        <div class="left_side">
            <div class="left_opacity"></div>


            <h2 class="achieve_head">My Achievements</h2>

            <div class="achievemts_badges_contaier">
                <div class="badge_col">
                    <div class="badge_img"><img src="../../assets/images/ignite-icon2/Learning-Star.svg" alt=""></div>
                    <div class="badge_name">Learning Star</div>
                </div>

                <div class="badge_col">
                    <div class="badge_img"><img src="../../assets/images/ignite-icon2/Learning-Champ.svg" alt=""></div>
                    <div class="badge_name">Learning Champ</div>
                </div>

                <div class="badge_col">
                    <div class="badge_img"><img src="../../assets/images/ignite-icon2/Pro.svg" alt=""></div>
                    <div class="badge_name">PRO</div>
                </div>

                <div class="badge_col">
                    <div class="badge_img"><img src="../../assets/images/ignite-icon2/Master-Gray.svg" alt=""></div>
                    <div class="badge_name">Master</div>
                </div>

                <div class="badge_col">
                    <div class="badge_img"><img src="../../assets/images/ignite-icon2/Star-Gray.svg" alt=""></div>
                    <div class="badge_name">Star</div>
                </div>
            </div>

            <div class="misc_container">
                <div class="programs_container">


                    <div class="program_misc_contaier">
                        <div class="all_programs">
                            <h2 class="program_head">Programs</h2>

                            <div class="pro_rows">
                                <div class="row_1">
                                    <div class="program_img_container">
                                        <div class="image_opacity"></div><img class="prog_img" src="../../assets/images/progress.svg" alt=""> <img
                                            src="../../assets/images/setting_arrow.svg" alt="" class="overlap_icon">
                                    </div>

                                    <div class="progress_display">
                                        <div class="status">In Progress</div>
                                        <div class="progress_number">4</div>
                                    </div>

                                </div>

                                <div class="row_1">
                                    <div class="program_img_container">
                                        <div class="image_opacity"></div><img class="prog_img" src="../../assets/images/progress.svg" alt=""> <img
                                            src="../../assets/images/time.svg" alt="" class="overlap_icon">
                                    </div>

                                    <div class="progress_display">
                                        <div class="status" style="color: rgba(255, 0, 0, 1);">Not Started</div>
                                        <div class="progress_number" style="color: rgba(255, 0, 0, 1); background: rgba(255, 233, 233, 1);">4</div>
                                    </div>
                                </div>

                                <div class="row_1">
                                    <div class="program_img_container">
                                        <div class="image_opacity"></div><img class="prog_img" src="../../assets/images/progress.svg" alt=""> <img
                                            src="../../assets/images/complete.svg" alt="" class="overlap_icon">
                                    </div>

                                    <div class="progress_display">
                                        <div class="status" style="color: rgba(62, 218, 106, 1);">Completed</div>
                                        <div class="progress_number" style="color: rgba(62, 218, 106, 1); background: rgba(238, 255, 240, 1);">10
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div class="graph_act_container">
                            <div class="graph_container btnn btnn-default">
                                <div id="chart" class="area_chart">
                                    <div class="average_socre">Avgerage Score</div>
                                    <div class="percentage">78%</div>
                                    <apx-chart [grid]="chartOptions.grid" [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                                        [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
                                        [dataLabels]="chartOptions.dataLabels"></apx-chart>
                                </div>

                            </div>
                            <div class="activity_quiz_container btnn2 btnn-default2">
                                <div class="quiz_box">
                                    <div class="quiz_name">Activities
                                        Complete</div>
                                    <div class="img_numb">
                                        <img src="../../assets/images/q1.svg" alt="">
                                        <div class="numb">10</div>
                                    </div>
                                </div>

                                <div class="quiz_box">
                                    <div class="quiz_name">Games Played</div>
                                    <div class="img_numb">
                                        <img src="../../assets/images/q2.svg" alt="">
                                        <div style="color: rgba(138, 80, 252, 1);" class="numb">10</div>
                                    </div>
                                </div>

                                <div class="quiz_box">
                                    <div class="quiz_name">Video Played</div>
                                    <div class="img_numb">
                                        <span class="minute">min</span>
                                        <img src="../../assets/images/q3.svg" alt="">
                                        <div style="color: rgba(245, 71, 89, 1);" class="numb">100</div>
                                    </div>
                                </div>

                                <div class="quiz_box">
                                    <div class="quiz_name">Quiz Complete</div>
                                    <div class="img_numb">
                                        <img src="../../assets/images/q4.svg" alt="">
                                        <div style="color: rgba(1, 215, 154, 1);" class="numb">10</div>
                                    </div>
                                </div>

                                <div class="quiz_box">
                                    <div class="quiz_name">Comments</div>
                                    <div class="img_numb">
                                        <img src="../../assets/images/q5.svg" alt="">
                                        <div style="color: rgba(96, 184, 254, 1);" class="numb">10</div>
                                    </div>
                                </div>

                                <div class="quiz_box">
                                    <div class="quiz_name">Current Rating</div>
                                    <div class="img_numb">
                                        <img src="../../assets/images/q6.svg" alt="">
                                        <div style="color: rgba(254, 212, 45, 1);" class="numb">6/10</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>




                </div>


            </div>

        </div>

        <div class="right_side">

            <h2 class="achieve_head">My Satisfaction</h2>

            <div class="moods_container">
                <div class="progress_bar">

                    <div class="complete progress" style="height: 35px">

                        <div role="progressbar" class="progress-bar" [style.width]="'80%'"
                            aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            <div class="percent">80%</div>
                        </div>
                    </div>
                </div>

                <div class="moods_emojis">
                    <img src="../../assets/images/sad 1.svg" alt="">
                    <img src="../../assets/images/medium_mood.svg" alt="">
                    <img src="../../assets/images/happy_mood.svg" alt="">
                </div>
            </div>

            <div class="skill_board_container">

                <h2 class="skill_heda">Skill Board</h2>

                <div class="skill_rows">
                    <div class="skill_row">
                        <div class="skill_sub_head">Sales</div>
                        <div class="progress_bar" style="margin-bottom: 0px !important;">

                            <div class="complete progress" style="height: 28px;">

                                <div role="progressbar" class="progress-bar" style=" background: rgba(255, 206, 80, 1);"  [style.width]="'80%'" aria-valuenow="course.progressCompleted"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="percent">80%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="skill_row">
                        <div class="skill_sub_head">Presentation</div>
                        <div class="progress_bar" style="margin-bottom: 0px !important;">

                            <div class="complete progress" style="height: 28px;">

                                <div role="progressbar" class="progress-bar" style=" background: rgba(1, 215, 154, 1);"  [style.width]="'80%'" aria-valuenow="course.progressCompleted"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="percent">80%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="skill_row">
                        <div class="skill_sub_head">Behaviour</div>
                        <div class="progress_bar" style="margin-bottom: 0px !important;">

                            <div class="complete progress" style="height: 28px;">

                                <div role="progressbar" class="progress-bar" style=" background: rgba(116, 205, 255, 1);" [style.width]="'80%'" aria-valuenow="course.progressCompleted"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="percent">80%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="skill_row">
                        <div class="skill_sub_head">Customer Handling</div>
                        <div class="progress_bar" style="margin-bottom: 0px !important;">

                            <div class="complete progress" style="height: 28px;">

                                <div role="progressbar" class="progress-bar" style="background: rgba(245, 71, 89, 1);" [style.width]="'80%'" aria-valuenow="course.progressCompleted"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="percent">80%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="all_skills">All Skills</div>

            </div>

        </div>
    </div>
</div> -->